import { Layer } from "@deck.gl/core";
import { mapStore } from "src/js/stores/map/store";

export type LayerConstructor = new (...args: any[]) => Layer;

/**
 * Takes an array of DeckLayer classes and returns an array of the IDs of the
 * instances of those classes in the map store.
 * @param DeckLayerClasses Array of deck layer classes
 * @returns Array of IDs of the instances of the classes in the map store
 */
export function getDeckLayerInstanceIds(DeckLayerClasses: LayerConstructor[]) {
  return mapStore.deckLayers
    .map(({ layer }) => layer)
    .filter((layer) => DeckLayerClasses.some((Class) => layer instanceof Class))
    .map((layer) => layer.id);
}
